// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Y6NBb","inner":"Footer_inner__A1fPE","nextIcon":"Footer_nextIcon__1E-Bs","innerLeft":"Footer_innerLeft__TaSKe"};